import React, { useContext } from 'react'
import TableVideo from '../Video/TableVideo'
import Sidebar from '../Sidebar'
import { addcontext } from '../../ContextShare/ContextShare'
import klaimage from '../../Assets/kla-logo.png'
import { Icon } from '@iconify/react/dist/iconify.js'

function VideoR() {
    const { addVideo, setAddVideo } = useContext(addcontext)
    const { changeSeqNo, setChangeSeqNo } = useContext(addcontext)
    const { isSidebarCloses, setIsSidebarCloses } = useContext(addcontext)


    const handleAddvideo = () => {
        setAddVideo(!addVideo)
        setChangeSeqNo(false)
    }
    const handleChangeseqNo = () => {
        setChangeSeqNo(!changeSeqNo)
        setAddVideo(false)
    }
    return (
        <>
            <div className='flex w-full h-full ' style={{ fontFamily: 'ropa sans' }}>
                <div className='flex flex-col w-full h-full'>

                    <div className='w-full h-24 flex flex-row justify-between bg-success rounded border ' style={{ height: '13vh' }}>
                        {/* logo */}
                        <div className='w-2/12 flex items-center'>
                            <img src={klaimage} className='w-6/12 ms-12 lg:flex hidden p-1' alt="" /></div>

                        <div className='flex items-center' onClick={() => setIsSidebarCloses(!isSidebarCloses)}>
                        <Icon icon="teenyicons:expand-solid" className='text-2xl font-bold  cursor-pointer'/>
                        </div>

                        <div className='w-10/12 flex flex-row justify-end pr-5 gap-5'>
                            {/* button one */}
                            <div className={`flex md:w-52 w-4/12 items-center h-full`}>
                            <button className='flex w-full h-2/5 justify-center items-center rounded-full cursor-pointer text-white bg-blue-600 border hover:bg-blue-700 transform duration-500 ease-in-out'
                                    onClick={handleAddvideo}>
                                    <i class={`fa-solid ${addVideo ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                    <span className='lg:text-sm text-xs'>{!addVideo ? 'Add new videos' : 'Close'}</span>
                                </button>
                            </div>

                            {/* button two */}
                            <div className='flex md:w-52 w-4/12 items-center h-full '>
                            <button className='flex w-full h-2/5 justify-center items-center rounded-full cursor-pointer text-white bg-blue-600 border hover:bg-blue-700 transform duration-500 ease-in-out' 
                                        onClick={handleChangeseqNo}>
                                        <i class={`fa-solid ${changeSeqNo ? 'fa-xmark' : 'fa-pen-to-square'} md:me-2 me-1`}></i>
                                        <span className='lg:text-sm text-xs'>{!changeSeqNo ? 'Change sequence number' : 'Close'}</span>
                                    </button>
                                </div>
                        </div>

                    </div>

                    <div className='flex flex-row'>

                        <div className={`${isSidebarCloses && 'hidden'} md:w-4/12 lg:w-3/12 xl:w-2/12`}>
                            <Sidebar />
                        </div>


                        {/* Table */}
                        <div className={`${isSidebarCloses ? 'w-full' : 'lg:w-9/12 xl:w-10/12 w-full'} overflow-y-scroll pt-2 `} style={{ height: '87vh' }}>
                            <TableVideo />
                        </div>
                    </div>
                </div></div>
        </>
    )
}

export default VideoR